module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text2_en.a1ef04e3ee2e3be6506c22022bb783de.png";